import constants from '@/app-configs/constants'

export default [
  {
    path: '/economic',
    name: 'E-conomic',
    component: () => import('@/views/integrations/Econmic.vue'),
    meta: {
      pageTitle: 'E-conomic',
      breadcrumb: [
        {
          text: 'E-conomic',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
      nav: false,
    },
  },
  {
    path: '/dinero',
    name: 'Dinero',
    component: () => import('@/views/integrations/Dinero.vue'),
    meta: {
      pageTitle: 'Dinero',
      breadcrumb: [
        {
          text: 'Dinero',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
      nav: false,
    },
  },
]
